import type { ConsultantBulkCreateReport } from '@shared/dto/deadline/consultant-deadline-write.response';

/** Scadenze create senza la firma richiesta: l'esito va mostrato anche se non manca nessun cliente. */
export function hasSignatureSkipped(report: ConsultantBulkCreateReport): boolean {
  return report.created.some((created) => created.companySignatureUnavailable === true);
}

/**
 * Quanti dei clienti scelti possono firmare dall'app. Il dato arriva dal server con il cliente
 * (`canRequestCompanySignature`); un cliente senza il dato (bozza dell'assistente) non blocca la
 * scelta: decide il server, che lo segnala nell'esito.
 */
export type CompanySignatureAvailability = 'ALL' | 'SOME' | 'NONE';

export function resolveCompanySignatureAvailability(
  tenantIds: readonly string[],
  signatureAvailabilityByTenant: Readonly<Record<string, boolean>>,
): CompanySignatureAvailability {
  const availableCount = tenantIds.filter(
    (tenantId) => signatureAvailabilityByTenant[tenantId] !== false,
  ).length;
  if (tenantIds.length === 0 || availableCount === tenantIds.length) {
    return 'ALL';
  }
  return availableCount === 0 ? 'NONE' : 'SOME';
}
